import { Button, Datepicker } from "@bphxd/ds-core-react";
import { Down16, Remove24 } from "@bphxd/ds-core-react/lib/icons";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import "./Filter.scss";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { DrnViewModel } from "../../model/DrnViewModel";
//import { fetchFilterSearchResult, fetchFilterRegionSearchResult } from "../../api/DRN/drnsearch";
import moment from "moment";
 
function MultiSelectDropdown({ label, items, selected, onToggle, disabled = false }: {
  label: string; items: string[]; selected: string[];
  onToggle: (item: string) => void; disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");//(search functionality in dropdown)
 
  const ref = useRef<HTMLDivElement>(null);
 
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
 
  useEffect(() => {
  if (!open) setSearch("");
}, [open]); //to clear search text when dropdown is closed
 
 
 
  return (
    <div ref={ref} className="w-100" style={{ position: "relative" }}>
   
     <button
  type="button"
  disabled={disabled}
  className="w-100 sch-drpdwn-toggle rounded-0 ft-size btn"
 
  onClick={() => !disabled && setOpen(o => !o)}
>
<span>
    {selected.length===0 ? label : `${label}(${selected.length})`}
    </span>
  <Down16
    style={{ color: "#2e7d32" }}
    className="btn-icon-suffix"
  />
</button>
    {open && (
  <div className="dropdown-menu show w-90 ft-size dropdown-list">
 {/* search  ITEMS */}
   {items.length === 0 ? (
  <div
    className="dropdown-item"
    style={{
      color: "#6c757d",
      padding: "2px 2px",
      cursor: "default",
      pointerEvents: "none"
    }}
  >
    No matching values
  </div>
) : (
  <div className="dropdown-search">
    <input
      type="text"
      placeholder="Search..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      className="dropdown-search-input"
    />
  </div>
)}
 
                                 
    {/* FILTERED ITEMS */}
    {items
      .filter(item => item.toLowerCase().includes(search.toLowerCase()))
      .map(item => (
        <button type="button" key={item}
          className="dropdown-item ft-size d-flex align-items-center justify-content-between"
          style={{ fontWeight: selected.includes(item) ? 600 : 400 }}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => { e.stopPropagation(); onToggle(item); }}>
          <span >{item}</span>
          {selected.includes(item) && <span style={{ color: "#000000", fontSize: 14 }}>✓</span>}
        </button>
    ))}
  </div>
)}
 
{/* SELECTED PILLS */}
{selected.length > 0 && (
  <div className="selected-pills">
    {selected.map((s) => (
      <span key={s} className="selected-pill">
        <span title={s} className="selected-pill-text">
          {s.length > 22 ? `${s.substring(0, 22)}....` : s}
        </span>
 
        <span
          className="selected-pill-close"
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            onToggle(s);
          }}
        >
          ×
        </span>
      </span>
    ))}
  </div>
)}
   
    </div>
  );
}
 
export default function Filter({
  selectedField,
  rowData,
  dropdownData,
  //setRowData,
  //nonFilteredRowData,
  setEnableAgGrid,
  setNoDatafound,
  //setIsLoading,
  deepFilter,
  setFilterQueryParams,
  clearDeepFilter,
  searchValsState,
  setTotalRecordsCount,
  docTypeItem,
  regionDataFilter,
}: {
  selectedField: string;
  rowData: DrnViewModel[];
  dropdownData:any;
 
  //setRowData: Dispatch<SetStateAction<DrnViewModel[]>>;
  //nonFilteredRowData: DrnViewModel[];
  setEnableAgGrid: Dispatch<SetStateAction<boolean>>;
  setNoDatafound: React.Dispatch<React.SetStateAction<string>>;
  //setIsLoading: Dispatch<SetStateAction<boolean>>;
  deepFilter: (filterParamObj: any, offSet: number, shouldCallDropdownApi?: boolean) => Promise<void>;
  setFilterQueryParams: Dispatch<any>;
  clearDeepFilter: () => void;
  searchValsState: {
    sField: string;
    sText: string;
    sRegion: string[];
    sCountry: string[];
    sPort: string[];
  };
  setTotalRecordsCount: React.Dispatch<React.SetStateAction<number>>;
  docTypeItem: string[];
  regionDataFilter: any;
}) {
  const [enableDocTypeDropDown, setEnbleDocTypeDropDown] =
    useState<boolean>(false);
  const [enableDocTypeDropDown1, setEnbleDocTypeDropDown1] =
    useState<boolean>(false);
  const [enableNominationField, setEnableNominationField] =
    useState<boolean>(false);
  const [enableDeliveryDateField, setEnbleDeliveryDateField] =
    useState<boolean>(false);
  const [enableInvoiceDateField, setEnbleInvoiceDateField] =
    useState<boolean>(false);
  const [enableInvoiceNumField, setEnbleInvoiceNumField] =
    useState<boolean>(false);
  const [enableBusiCnlDropDown, setEnbleBusiCnlDropDown] =
    useState<boolean>(false);
  const [enableCusSalArea, setEnbleCusSalArea] = useState<boolean>(false);
  const [enableCusAccName, setEnbleCusAccName] = useState<boolean>(false);
  const [enableCusAccName1, setEnbleCusAccName1] = useState<boolean>(false);
  const [enableRegionDropDown, setEnableRegionDropDown] =useState<boolean>(true);
  const [enableRegionDropDown1, setEnableRegionDropDown1] =useState<boolean>(false);
  const [enableContyDropDown, setEnableContyDropDown] =useState<boolean>(false);
  const[enableCustIDdropDown, setEnableCustIDdropDown] = useState<boolean>(false);
  const [enablePortDropDown, setEnablePortDropDown] = useState<boolean>(false);
  const [enableVesselNameDropDown, setEnableVesselNameDropDown] = useState<boolean>(false);
  const [enableVesselImoDropDown, setEnableVesselImoDropDown] = useState<boolean>(false);
  const [enableOrderNumberDropDown, setEnableOrderNumberDropDown] = useState(false);
  const [selectedDocTypes, setSelectedDocTypes] = useState<string[]>([]);
  const [businessChannel, setBusinessChannel] =useState<string>("Business Channel");
  const [selectedRegions, setSelectedRegions] = useState<string[]>([]);
  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
  const [selectedPorts, setSelectedPorts] = useState<string[]>([]);
 //nomination dd
  const [nominationNum, setNominationNum] = useState<string[]>([]);
  const [selectedNominationNum, setSelectedNominationNum] = useState<string[]>([]);
  //invoice dd
  const [invoiceNum, setInvoiceNum] = useState<string[]>([]);
  const [selectedInvoiceNum, setSelectedInvoiceNum] = useState<string[]>([]);
  const [cusSalesArea, setCusSalesArea] = useState<string>("");
//now for vessel and imo dd
  const [selectedVessels, setSelectedVessels] = useState<string[]>([]);
  const [selectedImos, setSelectedImos] = useState<string[]>([]);
  const [vesselOptions, setVesselOptions] = useState<string[]>([]);
   const[imoOptions, setImoOptions] = useState<string[]>([]);
//now for cust code and cust name dd
const [custCodeOptions, setCustCodeOptions] = useState<string[]>([]);
const[custNameOptions, setCustNameOptions] = useState<string[]>([]);
const [selectedCustCodes, setSelectedCustCodes] = useState<string[]>([]);
const[selectedCustNames, setSelectedCustNames] = useState<string[]>([]);
 
// All order numbers list and selected 
const [allOrderNumbers, setAllOrderNumbers] = useState<string[]>([]);
const [selectedOrderNumber, setSelectedOrderNumber] = useState<string[]>([]);
  //const [docTypeItem, setDocTypeItem] = useState<string[]>([]);
  const [busiUnitItem, setBusiUnitItem] = useState<string[]>([]);
  //const [regionItem, setRegionItem] = useState<string[]>([]);
  const [countryItem, setCuntryItem] = useState<any[]>([]);
  const [portItem, setPortItem] = useState<string[]>([]);
  const [disableCtry, setDisableCtry] = useState<boolean>(true);
  const [disablePrt, setDisablePrt] = useState<boolean>(true);
  const [startInvoiceDate, setStartInvoiceDate] = useState<string>("");
  const [endInvoiceDate, setEndInvoiceDate] = useState<string>("");
  const [startDeliveryDate, setStartDeliveryDate] = useState<string>("");
  const [endDeliveryDate, setEndDeliveryDate] = useState<string>("");
  const deliveryDateRefComp = useRef<any>(null);
  const invoiceDateRefComp = useRef<any>(null);
 
  // useEffect(() => {
  //   clearfilters();
  // }, [nonFilteredRowData]);
  useEffect(()=>{
 
    resetFilterInputFields();
  },[searchValsState]);
 
  useEffect(()=>{
    console.log("region data filter",regionDataFilter);
  },[regionDataFilter]);
 
  useEffect(() => {
    resetFilterInputFields();
    if (
      selectedField === "order_number" ||
      selectedField === "nomination_number" ||
      selectedField === "isp_gq/gr_number"
    ) {
      setEnbleDocTypeDropDown(true);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleInvoiceNumField(true);
      setEnbleBusiCnlDropDown(false);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(false);
      setEnableRegionDropDown(false);
      setEnableContyDropDown(false);
      setEnablePortDropDown(false);
      setEnableVesselNameDropDown(false);
      setEnableVesselImoDropDown(true);
      setEnbleDocTypeDropDown1(false);
      setEnbleCusAccName1(false);
      setEnableRegionDropDown1(false);
    } else if (selectedField === "invoice_number") {
      setEnbleDocTypeDropDown(true);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleBusiCnlDropDown(false);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(false);
      setEnableRegionDropDown(false);
      setEnableContyDropDown(false);
      setEnablePortDropDown(false);
      setEnableVesselNameDropDown(false);
      setEnableVesselImoDropDown(false);
      setEnbleDocTypeDropDown1(false);
      setEnbleCusAccName1(false);
      setEnableRegionDropDown1(false);
    }
    else if (selectedField === "cust_acct_name") {
      setEnbleDocTypeDropDown(false);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleInvoiceNumField(true);
      setEnableRegionDropDown(true);
      setEnableContyDropDown(true);
      setEnablePortDropDown(true);
      setEnableVesselNameDropDown(true);
      setEnableVesselImoDropDown(true);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(true);
      setEnbleBusiCnlDropDown(false);
      setEnbleDocTypeDropDown1(true);
      setEnbleCusAccName1(false);
      setEnableRegionDropDown1(false);
      setEnableOrderNumberDropDown(true);
    } else if (selectedField === "country_name") {
      setEnbleDocTypeDropDown(false);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleInvoiceNumField(true);
      setEnableRegionDropDown(false);
      setEnableContyDropDown(false);
      setEnablePortDropDown(false);
      setEnableVesselNameDropDown(true);
      setEnableVesselImoDropDown(true);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(true);
      setEnbleBusiCnlDropDown(false);
      setDisableCtry(false);
      setDisablePrt(false);
      setEnbleCusAccName1(false);
      setEnbleDocTypeDropDown1(true);
      setEnableRegionDropDown1(false);
      setEnableOrderNumberDropDown(true);

    } else if (selectedField === "port_name") {
      setEnbleDocTypeDropDown(false);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleInvoiceNumField(true);
      setEnableRegionDropDown(true);
      setEnableContyDropDown(false);
      setEnablePortDropDown(false);
       setEnableVesselNameDropDown(true);
      setEnableVesselImoDropDown(true);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(true);
      setEnbleBusiCnlDropDown(false);
      setEnbleDocTypeDropDown1(true);
      setEnbleCusAccName1(false);
      setEnableOrderNumberDropDown(true);
      setEnableRegionDropDown1(true);
      setDisableCtry(false);
      setDisablePrt(false);
    } else if (selectedField === "region_name") {
      setEnbleDocTypeDropDown(false);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleInvoiceNumField(true);
      setEnableRegionDropDown(false);
      setEnableContyDropDown(false);
      setEnablePortDropDown(false);
       setEnableVesselNameDropDown(true);
      setEnableVesselImoDropDown(true);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(true);
      setEnbleBusiCnlDropDown(false);
      setEnbleDocTypeDropDown1(true);
      setEnbleCusAccName1(false);
      setDisableCtry(false);
      setDisablePrt(false);
      setEnableOrderNumberDropDown(true);

    } else if (selectedField === "vessel_name") {
      setEnbleDocTypeDropDown(false);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleInvoiceNumField(true);
      setEnableVesselImoDropDown(true);
      setEnableRegionDropDown(true);
      setEnableContyDropDown(true);
      setEnablePortDropDown(true);
      setEnableVesselNameDropDown(false);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(true);
      setEnbleBusiCnlDropDown(false);
      setEnbleDocTypeDropDown1(true);
      setEnbleCusAccName1(true);
      setEnableOrderNumberDropDown(true);

    }
    else if (selectedField === "vessel_imo_number") {
      setEnbleDocTypeDropDown(false);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleInvoiceNumField(true);
      setEnableVesselImoDropDown(false);
      setEnableRegionDropDown(true);
      setEnableContyDropDown(true);
      setEnablePortDropDown(true);
      setEnableVesselNameDropDown(true);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(true);
      setEnbleBusiCnlDropDown(false);
      setEnbleDocTypeDropDown1(true);
      setEnbleCusAccName1(true);
      setEnableOrderNumberDropDown(true);

    }
    else if (selectedField === "cust_code") {
      setEnbleDocTypeDropDown(false);
      setEnableNominationField(true);
      setEnbleDeliveryDateField(true);
      setEnbleInvoiceDateField(true);
      setEnbleInvoiceNumField(true);
      setEnableVesselImoDropDown(true);
      setEnableRegionDropDown(true);
      setEnableContyDropDown(true);
      setEnablePortDropDown(true);
      setEnableVesselNameDropDown(true);
      setEnbleCusSalArea(false);
      setEnbleCusAccName(true);
      setEnableCustIDdropDown(false);
      setEnbleBusiCnlDropDown(false);
      setEnbleDocTypeDropDown1(true);
      setEnbleCusAccName1(true);
      setEnableOrderNumberDropDown(true);
    }
  }, [selectedField]);
 
 
  const handleRegionToggle = (name: string) => {
  setSelectedRegions(prev =>
    prev.includes(name) ? prev.filter(r => r !== name) : [...prev, name]
  );
};
 
const handleCountryToggle = (name: string) => {
  setSelectedCountries(prev =>
    prev.includes(name) ? prev.filter(r => r !== name) : [...prev, name]
  );
};
 
const handlePortToggle = (name: string) => {
  setSelectedPorts(prev =>
    prev.includes(name) ? prev.filter(r => r !== name) : [...prev, name]
  );
};
 
const handleDocTypeToggle = (name: string) => {
  setSelectedDocTypes(prev =>
    prev.includes(name) ? prev.filter(d => d !== name) : [...prev, name]
  );
};
 
const handleVesselToggle = (name: string) => {
  setSelectedVessels(prev =>
    prev.includes(name) ? prev.filter(d => d !== name) : [...prev, name]
  );
};
 
const handleImoToggle = (name: string) => {
  setSelectedImos(prev =>
    prev.includes(name) ? prev.filter(d => d !== name) : [...prev, name]
  );
};
 
const handleCustNameToggle = (name: string) => {
  setSelectedCustNames(prev =>
    prev.includes(name) ? prev.filter(d => d !== name) : [...prev, name]
  );
};
 
const handleCustCodeToggle = (name: string) => {
  setSelectedCustCodes(prev =>
    prev.includes(name) ? prev.filter(d => d !== name) : [...prev, name]
  );
};
const handleNominationToggle = (name: string) => {
  setSelectedNominationNum(prev =>
    prev.includes(name)
      ? prev.filter(n => n !== name)
      : [...prev, name]
  );
};

const handleInvoiceToggle = (name: string) => {
  setSelectedInvoiceNum(prev =>
    prev.includes(name)
      ? prev.filter(i => i !== name)
      : [...prev, name]
  );
};
const handleOrderNumberToggle = (orderNumber: string) => {
  setSelectedOrderNumber(prev =>
    prev.includes(orderNumber)
      ? prev.filter(order => order !== orderNumber)
      : [...prev, orderNumber]
  );
};
 
 // too see selectd value add here console.log
 console.log("selectedInvoice",selectedInvoiceNum);
 
useEffect(() => {
  setEnableContyDropDown(selectedRegions.length > 0);
  if (!regionDataFilter?.length ) {
    setCuntryItem([]);
    setSelectedCountries([]);
    return;
  }
  const allCountries = selectedRegions.flatMap(rName => {
    const found = regionDataFilter.find((r: any) => r.region_name === rName);
    return found ? found.country_name : [];
  }).sort((a: any, b: any) => a.name < b.name ? -1 : 1);
  setCuntryItem(allCountries);
  setSelectedCountries((prev) => prev.filter(c => allCountries.some((ac: any) => ac.name === c))); // REMOVE COUNTRIES NOT IN NEW LIST
}, [selectedRegions, regionDataFilter]);
 
 
useEffect(() => {
  setEnablePortDropDown(selectedCountries.length > 0);
  if (!countryItem?.length ) {
      setPortItem([]);
      setSelectedPorts([]);
  return;
  }
  const allPorts = selectedCountries.flatMap(cName => {
    const found = countryItem.find((c: any) => c.name === cName);
    return found ? found.port_name : [];
  }).sort((a: string, b: string) => a < b ? -1 : 1);
 
  setPortItem(allPorts);
  setSelectedPorts((prev) => prev.filter(p => allPorts.includes(p))); // REMOVE PORTS NOT IN NEW LIST
}, [selectedCountries,countryItem]);
 
 
 
const cleanArrayField = (value: any): string[] => {
  return Array.from(
    new Set(
      String(value || "")
        .replace(/[{}"]/g, "")
        .split(",")
        .map((item) => item.trim().toUpperCase())
        .filter(
          (item) =>
            item &&
            item !== "NULL" &&
            item !== "NOT CLASSIFIED" &&
            item !== "N/A" &&
            item !== "NO NUMBER YET"
        )
    )
  );
};

//hamdgilg drop-down of secondary filter
useEffect(() => {
 
  if (!dropdownData?.length)
  {
    setVesselOptions([]);
    setImoOptions([]);
    setCustCodeOptions([]);
    setCustNameOptions([]);
    setNominationNum([]);
    setAllOrderNumbers([]);
    return;
  }
 
  const vessels: string[] = [];
  const imos: string[] = [];
  const custCodes: string[] = [];
  const custNames: string[] = [];
  const nominations: string[] = [];
  const invoices: string[] = [];
  const orderNumbers: string[] = [];

 
  dropdownData.forEach((item: any) => {
    vessels.push(...cleanArrayField(item.vessel_name));
    imos.push(...cleanArrayField(item.vessel_imo_number));
    custCodes.push(...cleanArrayField(item.cust_code));
    custNames.push(...cleanArrayField(item.cust_acct_name));
    nominations.push(...cleanArrayField(item.nomination_number));
    invoices.push(...cleanArrayField(item.invoice_number));
    orderNumbers.push(...cleanArrayField(item.order_number));

    
  });
 
 
 setVesselOptions(Array.from(new Set(vessels)));
setImoOptions(Array.from(new Set(imos)));
setCustCodeOptions(Array.from(new Set(custCodes)));
setCustNameOptions(Array.from(new Set(custNames)));
setNominationNum(Array.from(new Set(nominations)));
setInvoiceNum(Array.from(new Set(invoices)));
setAllOrderNumbers(Array.from(new Set(orderNumbers)));
}, [dropdownData]);
 
const clearDate = (ref: any, type: string): void => {
  if (type === "delivery") {
    setStartDeliveryDate("");
    setEndDeliveryDate("");
  }

  if (type === "invoice") {
    setStartInvoiceDate("");
    setEndInvoiceDate("");
  }

  ref?.current?.flatpickr?.clear();
};


//vessel name and their filter imo
 
useEffect(() => {
  if(!dropdownData?.length) return;
 
  //no vessel selected, show all imo options
  if (selectedVessels.length === 0) {
    const allImos: string[] = [];
 
    dropdownData?.forEach((item: any) => {
      allImos.push(...cleanArrayField(item.vessel_imo_number));
    });
 
    setImoOptions(Array.from(new Set(allImos)));
    return;
  }
 
  //vessel selected, filter imo options based on selected vessels
 
  const FilterImos: string[] = [];
 
  dropdownData?.forEach((item: any) => {
    const vessels = cleanArrayField(item.vessel_name);
 
    if (vessels.some((v) => selectedVessels.includes(v))) {
      FilterImos.push(...cleanArrayField(item.vessel_imo_number));
    }
  });
 
  setImoOptions(Array.from(new Set(FilterImos)));
}, [selectedVessels, dropdownData]);
 
//vessel imo and their filter vessel name
 
useEffect(() => {
  if(!dropdownData?.length) return;
  //no imo selected, show all vessel options
  if (selectedImos.length === 0) {
    const allVessels: string[] = [];
 
    dropdownData?.forEach((item: any) => {
      allVessels.push(...cleanArrayField(item.vessel_name));
    });
 
    setVesselOptions(Array.from(new Set(allVessels)));
    return;
  }
 
  //imo selected, filter vessel options based on selected imos
 
  const filteredVessels: string[] = [];
 
  dropdownData?.forEach((item: any) => {
    const imos = cleanArrayField(item.vessel_imo_number);
 
    if (imos.some((imo) => selectedImos.includes(imo))) {
      filteredVessels.push(...cleanArrayField(item.vessel_name));
    }
  });
 
  setVesselOptions(Array.from(new Set(filteredVessels)));
}, [selectedImos, dropdownData]);
 
//customer code and customer name filter
 
useEffect(() => {
  if(!dropdownData?.length) return;
  if (selectedCustCodes.length === 0) {
    const allCustNames: string[] = [];
 
    dropdownData?.forEach((item: any) => {
      allCustNames.push(...cleanArrayField(item.cust_acct_name));
    });
 
    setCustNameOptions(Array.from(new Set(allCustNames)));
    return;
  }
 
  //cust code selected, filter customer name options based on selected customer codes
 
  const filteredCustNames: string[] = [];
 
  dropdownData?.forEach((item: any) => {
    const custCodes = cleanArrayField(item.cust_code);
 
    if (custCodes.some((code) => selectedCustCodes.includes(code))) {
      filteredCustNames.push(...cleanArrayField(item.cust_acct_name));
    }
  });
 
  setCustNameOptions(Array.from(new Set(filteredCustNames)));
}, [selectedCustCodes, dropdownData]);
 
//customer name and customer code filter
useEffect(() => {
  if(!dropdownData?.length) return;
  if (selectedCustNames.length === 0) {
    const allCustCodes: string[] = [];
 
    dropdownData?.forEach((item: any) => {
      allCustCodes.push(...cleanArrayField(item.cust_code));
    });
 
    setCustCodeOptions(Array.from(new Set(allCustCodes)));
    return;
  }
  //cust name selected, filter customer code options based on selected customer names
 
  const filteredCustCodes: string[] = [];
 
  dropdownData?.forEach((item: any) => {
    const custNames = cleanArrayField(item.cust_acct_name);
 
    if (custNames.some((name) => selectedCustNames.includes(name))) {
      filteredCustCodes.push(...cleanArrayField(item.cust_code));
    }
  });
 
  setCustCodeOptions(Array.from(new Set(filteredCustCodes)));
}, [selectedCustNames, dropdownData]);
 
 
 const validateAndFilter = () => {
  filterData();
};
 
  const filterData = async () => {
    //setIsLoading(true);
    let filterParamObj: any = {};
    // let filteredData: DrnViewModel[] = [];
    if (businessChannel !== "Business Channel") {
      filterParamObj = {
        ...filterParamObj,
        bussiness_channel: businessChannel,
      };
    }
   if (selectedDocTypes.length > 0){
    filterParamObj = { ...filterParamObj, document_type: selectedDocTypes };
 
   }
 
    if (nominationNum.length>0) {
      filterParamObj = { ...filterParamObj, nomination_number: selectedNominationNum };
    }
    if (invoiceNum.length>0) {
      filterParamObj = { ...filterParamObj, invoice_number: selectedInvoiceNum };
    }
    if (selectedOrderNumber.length > 0) {
      filterParamObj = { ...filterParamObj, order_number: selectedOrderNumber };
    }
    if (cusSalesArea !== "") {
      filterParamObj = { ...filterParamObj, country_name: cusSalesArea }; //Customer sales area filter is applied on country column
    }
    if (startDeliveryDate !== "") {
      filterParamObj = {
        ...filterParamObj,
        s_delivery_date: moment(startDeliveryDate).format("YYYY-MM-DD"),
      };
    }
    if (endDeliveryDate !== "") {
      filterParamObj = {
        ...filterParamObj,
        e_delivery_date: moment(endDeliveryDate).format("YYYY-MM-DD"),
      };
    }
    if (startInvoiceDate !== "") {
      filterParamObj = {
        ...filterParamObj,
        s_invoice_date: moment(startInvoiceDate).format("YYYY-MM-DD"),
      };
    }
    if (endInvoiceDate !== "") {
      filterParamObj = {
        ...filterParamObj,
        e_invoice_date: moment(endInvoiceDate).format("YYYY-MM-DD"),
      };
    }
    if(selectedCustCodes.length>0){
      filterParamObj={
        ...filterParamObj,cust_code:selectedCustCodes
      };
    }
    if(selectedCustNames.length>0){
      filterParamObj={
        ...filterParamObj,cust_acct_name:selectedCustNames
      };
    }
   
    if (selectedRegions.length > 0){
      filterParamObj = { ...filterParamObj, region_name: selectedRegions };
    }
 
    if (selectedCountries.length > 0) {
      filterParamObj = { ...filterParamObj, country_name: selectedCountries };
    }
    if (selectedPorts.length > 0 ) {
      filterParamObj = { ...filterParamObj, port_name: selectedPorts };
    }
   
    if(selectedVessels.length>0){
      filterParamObj={
        ...filterParamObj,vessel_name:selectedVessels
      };
    }
 
    if(selectedImos.length>0){
      filterParamObj={
        ...filterParamObj,vessel_imo_number:selectedImos
      };
    }
 
    setFilterQueryParams(filterParamObj);
    console.log("searchValsState", searchValsState);
    console.log("filterParamObj", filterParamObj);
    deepFilter(filterParamObj,0,true);  
    // filteredData = nonFilteredRowData.filter(search, filterParamObj);
    // function search(this: any, item: any) {
    //   return Object.keys(this).every(
    //     (key) => item[key] + "".toLowerCase() === this[key] + "".toLowerCase()
    //   );
    // }
    // if (cusName !== "") {
    //   filteredData = filteredData.filter((item) => {
    //     if (
    //       item.cust_acct_name.toLowerCase().indexOf(cusName.toLowerCase()) >= 0
    //     )
    //       return true;
    //     else return false;
    //   });
    // }
    // if (vessel !== "") {
    //   filteredData = filteredData.filter((item) => {
    //     if (item.vessel_name.toLowerCase().indexOf(vessel.toLowerCase()) >= 0)
    //       return true;
    //     else return false;
    //   });
    // }
    // if (deliveryDate !== "") {
    //   filteredData = filteredData.filter((item) => {
    //     return (
    //       moment(item.actl_del_date).format("DD MMM YYYY") === deliveryDate
    //     );
    //   });
    // }
    // if (invoiceDate !== "") {
    //   filteredData = filteredData.filter((item) => {
    //     return moment(item.invoice_date).format("DD MMM YYYY") === invoiceDate;
    //   });
    // }
    // if (result.data.length > 0) {
    //   setRowData(result.data);
    //   //setNoDatafound(false);
    //   //setEnableAgGrid(true);
    // } else {
    //   //setNoDatafound(true);
    //   //setEnableAgGrid(false);
    // }
    // setIsLoading(false);
  };
 
  const resetFilterInputFields = () => {
    setSelectedDocTypes([]);
    setBusinessChannel("Business Channel");
    setNominationNum([]);
    setSelectedNominationNum([]);
    setInvoiceNum([]);
    setSelectedInvoiceNum([]);
    setAllOrderNumbers([]);
    setSelectedOrderNumber([]);
    setCusSalesArea("");
    setSelectedVessels([]);
    setSelectedImos([]);
    setVesselOptions([]);
    setImoOptions([]);
    setSelectedCustCodes([]);
    setSelectedCustNames([]);
    setCustCodeOptions([]);
    setCustNameOptions([]);
    setStartDeliveryDate("");
    setEndDeliveryDate("");
    setStartInvoiceDate("");
    setEndInvoiceDate("");
    deliveryDateRefComp.current?.flatpickr.clear();
    invoiceDateRefComp.current?.flatpickr.clear();
    //setNoDatafound(false);
    //setEnableAgGrid(true);
    setSelectedRegions([]);
    setSelectedCountries([]);
    setSelectedPorts([]);
    if (selectedField === "cust_acct_name" || selectedField === "vessel_name") {
      setDisableCtry(true);
      setDisablePrt(true);
    }
  };

 const isSecondaryFilterApplied =
  selectedDocTypes.length > 0 ||
  selectedNominationNum.length > 0 ||
  selectedInvoiceNum.length > 0 ||
  selectedOrderNumber.length > 0 ||
  selectedVessels.length > 0 ||
  selectedImos.length > 0 ||
  selectedCustCodes.length > 0 ||
  selectedCustNames.length > 0 ||
  selectedRegions.length > 0 ||
  selectedCountries.length > 0 ||
  selectedPorts.length > 0 ||
  !!cusSalesArea ||
  !!startDeliveryDate ||
  !!endDeliveryDate ||
  !!startInvoiceDate ||
  !!endInvoiceDate;
 
  const clearfilters = () => {
    clearDeepFilter();
    resetFilterInputFields();
    //setRowData(nonFilteredRowData);
  };
 
 
  const onCusSlAreaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCusSalesArea(e.currentTarget.value);
  };
 
 

 
  return (
   
    <>
      <div className="d-grid gap-4" >
        <div className="row" >
          <div className="fw-medium filter-text">Filter</div>
        </div>
 
        {enableDocTypeDropDown && (
  <div className="row"  >
      <label className="text-label"
    >
      Document Type
    </label>
    <MultiSelectDropdown
      label="Document Type"
      items={docTypeItem}
      selected={selectedDocTypes}
      onToggle={handleDocTypeToggle}
     
    />
  </div>
)}
 
{enableDocTypeDropDown1 && (
  <div className="row" >
    <label  className="text-label"
    >
      Document Type
    </label>
    <MultiSelectDropdown
      label="Document Type"
      items={docTypeItem}
      selected={selectedDocTypes}
      onToggle={handleDocTypeToggle}
    />
  </div>
)}
        
     
{enableNominationField && (
  <div className="row">
    <label className="text-label">
      ERP Order Number
    </label>

    <MultiSelectDropdown
      label="Select ERP Order Number"
      items={nominationNum}
      selected={selectedNominationNum}
      onToggle={handleNominationToggle}
    />
  </div>
)}
 {enableOrderNumberDropDown && (
  <div className="row">
    <label className="text-label">
      Order Number
    </label>

   

    <MultiSelectDropdown
      label="Select Order Number"
      items={allOrderNumbers}
      selected={selectedOrderNumber}
      onToggle={handleOrderNumberToggle}
    />
  </div>
)}
   {enableInvoiceNumField && (
  <div className="row">
    <label className="text-label">
      Invoice Number
    </label>

    <MultiSelectDropdown
      label="Select Invoice Number"
      items={invoiceNum}
      selected={selectedInvoiceNum}
      onToggle={handleInvoiceToggle}
    />
  </div>
)}
    {(enableVesselImoDropDown ) && (
  <div className="row">
    <label  className="text-label"
    >
      Vessel  IMO Number
    </label>
    <MultiSelectDropdown
    label="Select Vessel IMO"
    items={imoOptions}
    selected={selectedImos}
    onToggle={handleImoToggle}
    disabled={!enableVesselImoDropDown}
  />
  </div>
)}

  {enableDeliveryDateField && (
   <div className="col-12">
 
    <div  className="text-label">
      Delivery Date
    </div>
 
   <div className="filter_input_bg_left datepicker-wrapper" >
  <Datepicker
    placeholder="Delivery Date"
    className="datepicker ft-size"
    ref={deliveryDateRefComp}
    options={{
      onClose: function (
        selectedDates: any[],
        dateStr: string,
        instance: any
      ) {
        if (dateStr.includes("thru")) {
          setStartDeliveryDate(dateStr.split("thru")[0].trim());
          setEndDeliveryDate(dateStr.split("thru")[1].trim());
        } else {
          setStartDeliveryDate(dateStr);
          setEndDeliveryDate(dateStr);
          instance.setDate([selectedDates[0], selectedDates[0]], true);
        }
      },
      dateFormat: "d M Y",
      altFormat: "d M Y",
      ariaDateFormat: "d M Y",
      disableMobile: true,
      maxDate: new Date(),
      mode: "range",
      allowInput: false,
    }}
  />

{startDeliveryDate && (
  <Remove24
    onClick={() => clearDate(deliveryDateRefComp, "delivery")}
    className="clear-date-icon"
  />
)}

</div>
  </div>
)}
       {enableInvoiceDateField && (
  <div className="col-12">
 
    <div className="text-label"
    >
      Invoice Date
    </div>
 
    <div className="filter_input_bg_left datepicker-wrapper">
 
     <Datepicker
              placeholder="Invoice Date"
              className="datepicker ft-size"
              ref={invoiceDateRefComp}
              options={{
                onClose: function (selectedDates: any[], dateStr: string, instance: any) {
                  if (dateStr.includes("thru")) {
                    setStartInvoiceDate(dateStr.split("thru")[0].trim());
                    setEndInvoiceDate(dateStr.split("thru")[1].trim());
                    console.log("s_invDate ",dateStr.split("thru")[0].trim()," e_invDate ",dateStr.split("thru")[1].trim());
                  } else {
                    setStartInvoiceDate(dateStr);
                    setEndInvoiceDate(dateStr);
                    console.log("choosed oneinvdate ",dateStr);
                    instance.setDate([selectedDates[0],selectedDates[0]],true);
                  }
                },
                dateFormat: "d M Y",
                altFormat: "d M Y",
                ariaDateFormat: "d M Y",
                disableMobile: true,
                maxDate: new Date(),
                mode: 'range',
                allowInput: false
              }}
            />
            {startInvoiceDate && (
                         <Remove24
                        onClick={() => clearDate(invoiceDateRefComp, "invoice")}
                        className="clear-date-icon"
                           />
                      )}
          </div>
 
  </div>
)}
     
       
       {(enableCustIDdropDown ) && (
  <div className="row">
    <label  className="text-label"
    >
      Customer Sold-To-ID
    </label>
    <MultiSelectDropdown
    label="Select Customer Sold To ID "
    items={custCodeOptions}
    selected={selectedCustCodes}
    onToggle={handleCustCodeToggle}
    disabled={!enableCustIDdropDown}
  />
  </div>
)}
     
 
{(enableCusAccName ) && (
  <div className="row">
    <label  className="text-label"
    >
      Customer Account Name
    </label>
    <MultiSelectDropdown
    label="Select Customer Account Name"
    items={custNameOptions}
    selected={selectedCustNames}
    onToggle={handleCustNameToggle}
    disabled={!enableCusAccName}
  />
  </div>
)}
     
 
{(enableVesselNameDropDown ) && (
  <div className="row">
    <label  className="text-label"
    >
      Vessel  Name
    </label>
    <MultiSelectDropdown
    label="Select Vessel Name"
    items={vesselOptions}
    selected={selectedVessels}
    onToggle={handleVesselToggle}
    disabled={!enableVesselNameDropDown}
  />
  </div>
)}
 

 
{(enableRegionDropDown || enableRegionDropDown1) && (
  <div className="row">
      <label  className="text-label"
    >
               Region    
</label>
    <MultiSelectDropdown
      label="Region"
      items={regionDataFilter.map((r: any) => r.region_name)}
      selected={selectedRegions}
      onToggle={handleRegionToggle}
    />
  </div>
)}
     {(enableContyDropDown ) && (
  <div className="row">
    <MultiSelectDropdown
    label="Select Country"
    items={countryItem.map((c: any) => c.name)}
    selected={selectedCountries}
    onToggle={handleCountryToggle}
    disabled={!enableContyDropDown}
  />
  </div>
)}
 
     {(enablePortDropDown ) && (
  <div className="row">
    <MultiSelectDropdown
    label="Select Port"
    items={portItem}
    selected={selectedPorts}
    onToggle={handlePortToggle}
    disabled={!enablePortDropDown}
  />
  </div>
)}
 
       
       
        {enableBusiCnlDropDown && (
          <div className="row">
            <UncontrolledDropdown size="sm">
              <DropdownToggle
                className={
                  businessChannel === "Business Channel"
                    ? "w-100 sch-drpdwn-toggle rounded-0 text-secondary ft-size"
                    : "w-100 sch-drpdwn-toggle rounded-0 ft-size"
                }
                color="#fff"
                caret
              >
                {businessChannel}
                <Down16
                  color="#007f00 !important"
                  className="btn-icon-suffix"
                />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-sm w-100 ft-size">
                {busiUnitItem.map((item) => (
                  <div key={item}>
                    <DropdownItem
                      onClick={() => {
                        setBusinessChannel(item);
                      }}
                    >
                      {item}
                    </DropdownItem>
                    {/* {busiUnitItem.length - 1 !== index && (
                      <DropdownItem divider />
                    )} */}
                  </div>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        )}
        {enableCusSalArea && (
          <div className="row">
            <InputGroup size="sm" className="input-group-merge plc-color">
              <Input
                name="invoice"
                placeholder="Customer Sales Area"
                className="filter_textfld border-0 ft-size"
                onChange={onCusSlAreaChange}
                value={cusSalesArea}
              />
              <div className="input-group-append">
                <InputGroupText
                  className="filter_textfld border-0"
                  onClick={() => setCusSalesArea("")}
                >
                  {cusSalesArea !== "" && (
                    <Remove24 style={{ cursor: "pointer" }} />
                  )}
                </InputGroupText>
              </div>
            </InputGroup>
          </div>
        )}
     
 
      </div>
      <div
        className="d-flex justify-content-between filter-buttom-margin"
        style={{ marginTop: "1.5rem" }}
      >
        <Button
          level="secondary"
          rounded="pill"
          size="sm"
          theme="brand"
          className="clear-button ft-size"
          onClick={() => clearfilters()}
        >
          Clear
        </Button>
        <Button
          level="primary"
          rounded="pill"
          disabled={!isSecondaryFilterApplied}
          size="sm"
          theme="brand"
          className="search-button ft-size"
          onClick={() => {
            if (!isSecondaryFilterApplied) return;
            validateAndFilter();
            setTotalRecordsCount(0);
          }}
        >
          Submit
        </Button>
      </div>
    </>
  );
}
